module.exports = __webpack_public_path__ + "static/media/file-icon.7ad05060.svg";